/**
 * Canonical action families + banned ambiguous labels.
 */

import {
  PRODUCT_BANNED_AMBIGUOUS_ENGLISH_CTAS_V0,
  PRODUCT_PREFERRED_KOREAN_CTAS_V0,
} from '@shared/product-experience-canon-and-claim-boundary';

export const CANONICAL_ACTION_FAMILIES_V0 = [
  'Review',
  'Provide Information',
  'Request Execution',
  'Approve',
  'Deny',
  'Start',
  'Resume',
  'Retry',
  'Cancel',
  'Request Compensation',
  'Open Recovery',
  'View Receipt',
] as const;

export type CanonicalActionFamilyV0 = (typeof CANONICAL_ACTION_FAMILIES_V0)[number];

export const CANONICAL_ACTION_LABELS_KO_V0: Record<CanonicalActionFamilyV0, string> = {
  Review: '검토',
  'Provide Information': '정보 제공',
  'Request Execution': '실행 요청',
  Approve: '승인',
  Deny: '거부',
  Start: '시작',
  Resume: '재개',
  Retry: '다시 시도',
  Cancel: '취소',
  'Request Compensation': '보정 요청',
  'Open Recovery': '복구 열기',
  'View Receipt': '영수증 보기',
};

/** Standalone ambiguous labels banned on primary CTAs. */
export const BANNED_AMBIGUOUS_PRIMARY_LABELS_V0 = [
  ...PRODUCT_BANNED_AMBIGUOUS_ENGLISH_CTAS_V0,
  '처리 실패',
  'Something went wrong',
  'Invalid request',
  'No data',
] as const;

export const PREFERRED_ACTION_LABELS_V0 = PRODUCT_PREFERRED_KOREAN_CTAS_V0;

export function isBannedAmbiguousPrimaryLabel(label: string): boolean {
  const normalized = label.trim();
  return (BANNED_AMBIGUOUS_PRIMARY_LABELS_V0 as readonly string[]).some(
    (banned) => banned.toLowerCase() === normalized.toLowerCase()
  );
}

export function resolveActionLabelKo(family: CanonicalActionFamilyV0): string {
  return CANONICAL_ACTION_LABELS_KO_V0[family];
}
